var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 12.9515V16L7.4216 12.9515H11.2C12.0824 12.9515 12.8 12.2254 12.8 11.3326V4.85682C12.8 3.96398 12.0824 3.23788 11.2 3.23788H1.6C0.7176 3.23788 0 3.96398 0 4.85682V11.3326C0 12.2254 0.7176 12.9515 1.6 12.9515H2.4ZM1.6 4.85682H11.2V11.3326H6.9784L4 13.1409V11.3326H1.6V4.85682Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0H4.8C3.9176 0 3.2 0.726095 3.2 1.61894H12.8C13.6824 1.61894 14.4 2.34504 14.4 3.23788V9.71365C15.2824 9.71365 16 8.98755 16 8.09471V1.61894C16 0.726095 15.2824 0 14.4 0Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsBlue);
export default __webpack_public_path__ + "static/media/comments-blue.b40089444ab695f53a96e736bb9c9650.svg";
export { ForwardRef as ReactComponent };